module.exports = __webpack_public_path__ + "img/member_anniversary_02.411ae5ed.png";